import { connect } from 'react-redux'
import SuccessBar from '../components/ui/SuccessBar'
import { IStoreState } from '../types/index'

export function mapStateToProps(state: IStoreState): { success: { message: string } } {
  return {
    success: state.success
  }
}

export default connect(mapStateToProps)(SuccessBar)



// WEBPACK FOOTER //
// ./src/containers/SuccessBar.tsx